<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-book"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col class="white rounded-lg ml-4 d-flex justify-center " cols="8" style="height: 800px">
          <v-col class="mt-10 rounded-sm" cols="7" style="border: 1px dashed #696969; ; height: 300px">
            <div v-if="!file" style="height: 100%; width: 100%">
              <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true"
                   v-if="!loading" @dragleave="dragging = false">
                <div class="dropZone-info" @drag="onChange">
                  <span class="dropZone-title">DROP PORTFOLIO HERE</span>
                  <div class="dropZone-upload-limit-info">
                    <div>Or <span class="dropZone-title">load</span> from computer</div>
                  </div>
                </div>
                <v-file-input class="input" @change="onChange"></v-file-input>
              </div>
              <div v-else class="dropZone">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    class="dropZone-info"
                    style="right: 50%"
                ></v-progress-circular>
              </div>
            </div>
            <div v-else class="dropZone-uploaded">
              <div class="dropZone-uploaded-info">
                <span class="text-[16px] text-blue-101 font-normal "
                      style="font-size: 16px; color:#2D6097;font-weight: normal ">{{ file.name }}</span>
                <span class=" mb-3" style="font-size: 16px">{{ notification }}</span>
                <button class=" rounded-lg  pa-1 " style="border: 1px solid #2D6097"
                        @click="removeFile">Remove File
                </button>
              </div>

            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {UPDATE_FILE, UPLOAD_FILE} from "@/store/modules/portfolio";

export default {
  name: "Portfolio",
  data() {
    return {
      page: "Portfolio",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Portfolio",
          disabled: false,
        },
      ],
      file: '',
      dragging: false,
      notification: '',
      loading: false
    }
  },

  methods: {
    async onChange(e) {
      this.loading = true
      let formData = new FormData();
      formData.append("file", e);
      await this.$store.dispatch(`${UPLOAD_FILE}`, formData).then((data) => {
        if (data.data.status == 1) {
          this.loading = false
          this.createFile(e)
          this.notification = "Upload Successful"
          this.$store.dispatch(`${UPDATE_FILE}`, {file_id: data.data.data}).then((data) => {
              if (data.status == 1) {
              this.$toasted.success('Cập nhật thành công!', {
                duration: 1000,
                position: 'top-center'
              })
            }
          })
        }
      })
    },
    createFile(file) {
      this.file = file;
      this.dragging = false;
    },
    removeFile() {
      this.file = '';
    }
  }
}
</script>
<style scoped>
button:hover {
  background: #2D6097;
  color: white;
  border: 1px solid #2D6097;

}

.dropZone {
  width: 100%;
  height: 100%;
  position: relative;

}

.dropZone-info {
  color: #696969;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
  font-size: 14px;
}

.dropZone-title {
  color: #2D6097;
}

.input {
  position: absolute;
  cursor: pointer;
  top: 40%;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}


.dropZone-uploaded {
  width: 100%;
  height: 100%;
  position: relative;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

</style>
